import { render } from "./UserDefinedFieldListPage.vue?vue&type=template&id=767f9734&scoped=true&ts=true"
import script from "./UserDefinedFieldListPage.vue?vue&type=script&lang=ts"
export * from "./UserDefinedFieldListPage.vue?vue&type=script&lang=ts"

import "./UserDefinedFieldListPage.vue?vue&type=style&index=0&id=767f9734&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767f9734"]])

export default __exports__